import { useTranslation } from 'react-i18next'
import { Documents } from '~/features/africa/Cars/Documents'
import { PageContainer } from '~/shared/ui/Layout'
import {
  QuickNavigation,
  QuickNavigationOptions,
} from '~/shared/ui/QuickNavigation'

const quickNavigationOptions: QuickNavigationOptions = [
  { labelI18n: 'sts', anchor: 'sts' },
  { labelI18n: 'patent', anchor: 'patent' },
  { labelI18n: 'kasko', anchor: 'kasko' },
  { labelI18n: 'dc', anchor: 'dc' },
  { labelI18n: 'parkingCard', anchor: 'parkingCard' },
  { labelI18n: 'other', anchor: 'otherDocument' },
]

export const DocumentsPageAfrica = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('car documents')}>
      <Documents />

      <QuickNavigation options={quickNavigationOptions} />
    </PageContainer>
  )
}
